import React, {useEffect, useState, useContext} from 'react';
import {Block} from '../block';
import {Typography, Select, Alert} from 'antd';
import {OpenApiContext} from '../../openapi-context';

export function GlobalSecurityBlock({securityData, className, onSave, onCancel}) {
    const {state, dispatch} = useContext(OpenApiContext);
    const [securitySchemes, setSecuritySchemes] = useState();
    const [currentScheme, setCurrentScheme] = useState();

    useEffect(() => {
        setSecuritySchemes(state.securitySchemes());
        if (securityData) {
            setCurrentScheme(Object.keys(securityData)[0]);
        }
    }, [securityData]);

    function handleSave() {
        const globalSecurity = {[currentScheme]: []};
        dispatch({type: 'terminate'});
        return onSave && onSave(globalSecurity);
    }

    function handleCancel() {
        dispatch({type: 'terminate'});
        return onCancel && onCancel();
    }

    const triggerEdit = () => dispatch({type: 'activate', message: 'changes to specification security details'});

    const SecurityEdit = () => {
        return (
            <div className="frontpage">
                <Typography.Title level={3}>Global Security Scheme</Typography.Title>
                {securitySchemes && securitySchemes.length > 0 && (
                    <Select style={{width: '100%'}} value={currentScheme} onChange={(val) => setCurrentScheme(val)}>
                        {securitySchemes.map((ss) => (
                            <Select.Option key={ss.key} value={ss.key}>
                                {ss.name}
                            </Select.Option>
                        ))}
                    </Select>
                )}
                {(!securitySchemes || securitySchemes.length === 0) && <Alert type="warning" title="You need to create a security scheme in models first" />}
            </div>
        );
    };

    const SecurityView = () => {
        return securityData ? (
            <div>
                <Typography.Title level={4}>Global Security Scheme : {Object.keys(securityData)[0]}</Typography.Title>
            </div>
        ) : (
            <Typography.Title level={4}>NO SECURITY CONFIGURED</Typography.Title>
        );
    };

    return (
        <Block className={className} onCancel={handleCancel} onSave={handleSave} onEdit={triggerEdit}>
            {state.editMode ? <SecurityEdit /> : <SecurityView />}
        </Block>
    );
}
